import { useAppSelector } from "@/app/redux/hooks/reduxHooks"
import { seasonInfoProps } from "@/types/types.dashboard"
import ReactLoading from "react-loading"
import Image from "next/image"

type Props = {
    seasonInfo: seasonInfoProps
    seasonPass: number
}

export const SeasonStatusComponent = () => {
    const rank = useAppSelector((state) => state.dashboard.rank)
    const nextRank = useAppSelector((state) => state.dashboard.nextRank)
    const currentRankIcon = useAppSelector((state) => state.dashboard.currentRankIcon)

    return (
        <section className="flex items-center justify-start gap-5 font-thin">
            <div>
                {currentRankIcon && <Image src={currentRankIcon} width="50" height="50" alt="Your Season Pass Rank" />}
            </div>
            {rank ? (
                <div>
                    You are currently <strong>{rank}</strong> status.
                    {rank === "Gold" ? (
                        <p>Congratulations! You have reached the highest rank.</p>
                    ) : (
                        <p>
                            To be promoted to <strong>{nextRank}</strong>, you require the following:
                        </p>
                    )}
                </div>
            ) : (
                <ReactLoading type={"balls"} color={"#fff"} height={24} width={24} />
            )}
        </section>
    )
}
